import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["customField"];

  connect() {
    this.updateCustomFieldVisibility();
  }

  sanctionChanged(event) {
    this.updateCustomFieldVisibility();
  }

  updateCustomFieldVisibility() {
    const otherSanctionCheckbox = this.element.querySelector('input[data-sanction-code="other_sanction"]');
    const isOtherSanctionSelected = otherSanctionCheckbox && otherSanctionCheckbox.checked;
    
    if (this.hasCustomFieldTarget) {
      if (isOtherSanctionSelected) {
        this.customFieldTarget.classList.remove('hidden');
        // Required while « Autre sanction » is ticked.
        const textarea = this.customFieldTarget.querySelector('textarea');
        if (textarea) {
          textarea.required = true;
        }
      } else {
        this.customFieldTarget.classList.add('hidden');
        // Not required any more.
        const textarea = this.customFieldTarget.querySelector('textarea');
        if (textarea) {
          textarea.required = false;
          textarea.value = ''; // Vider le champ si not selected
        }
      }
    }
  }
} 